import React, { useImperativeHandle, useRef, useState } from 'react';
import cx from 'classnames';
import { isEmpty, isFunction, isNull, isString, isUndefined } from 'lodash/lang';
import { omit } from 'lodash/object';

import _File from './_File';
import _Password from './_Password';
import inputPropTypes from './types';

import './Input.scss';
import './Input.legacy.scss';

const Input = React.forwardRef(function(props, ref) {
  const {
    label,
    defaultValue,
    validate,
    validationMessage,
    valid,
    prefix,
    suffix,
    iconsAfter,
    className,
    legacyLook
  } = props;
  const propValue = props.value;
  const [value, setValue] = useState(isUndefined(propValue) ? defaultValue : propValue);

  const inputRef = useRef();
  useImperativeHandle(ref, () => inputRef.current);

  const isDefinedNewValue = !isUndefined(propValue);
  const isUndefinedNewValue = isUndefined(propValue) || isNull(propValue);
  const isDefinedCurrentValue = !isUndefined(value) && !isNull(value);
  const isNotEqualCurrentValueAndNewValue = propValue !== value;

  if (
    props.hasOwnProperty('value') &&
    ((isUndefinedNewValue && isDefinedCurrentValue) || (isDefinedNewValue && isNotEqualCurrentValueAndNewValue))
  ) {
    setValue(propValue);
  }

  const restProps = omit(
    props,
    'className',
    'label',
    'onChange',
    'defaultValue',
    'value',
    'validate',
    'validationMessage',
    'valid',
    'prefix',
    'suffix',
    'iconsAfter',
    'legacyLook'
  );

  const isNotValid = (isString(validationMessage) && validationMessage.length > 0) || !valid;

  return (
    <div
      className={cx('eui-input', className, {
        'eui-input-not-empty': !isEmpty(value) || value === 0,
        'eui-input-not-valid': isNotValid,
        'eui-input-legacy': legacyLook
      })}
    >
      <label>
        <input ref={inputRef} value={fixControlledValue(value)} onChange={onChange} {...restProps} />
        <span className="eui-input-face" />
        <span className="eui-input-prefix">{prefix}</span>
        <span className="eui-input-suffix">{suffix}</span>
        <span className="eui-input-icons-after">{iconsAfter}</span>
        <span className="eui-input-label">{label}</span>
      </label>
      {validate && <div className="eui-input-validation-message">{validationMessage}</div>}
    </div>
  );

  function onChange(e) {
    e.persist();
    const { onChange } = props;
    setValue(e.target.value);
    isFunction(onChange) && onChange(e);
  }
});

function fixControlledValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }
  return value;
}

Input.defaultProps = {
  valid: true,
  type: 'text',
  validate: true
};

Input.propTypes = inputPropTypes;

Input.Password = _Password;
Input.File = _File;

export default Input;
